import { render } from "./CreateAppModal.vue?vue&type=template&id=70828e16&scoped=true&ts=true"
import script from "./CreateAppModal.vue?vue&type=script&lang=ts"
export * from "./CreateAppModal.vue?vue&type=script&lang=ts"

import "./CreateAppModal.vue?vue&type=style&index=0&id=70828e16&lang=scss&scoped=true"

import exportComponent from "D:\\CTL-Project\\Mbf5_ZMP_CongAn\\CAXaAnQuang\\web-ui\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-70828e16"]])

export default __exports__